import { Sparkles, Coffee, Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";

interface VibeEchoTagProps {
  resonance?: {
    type: "rhythm" | "phrase" | "moment";
    description: string;
  };
  className?: string;
}

export const VibeEchoTag = ({ resonance, className }: VibeEchoTagProps) => {
  if (!resonance) return null;

  const getIcon = () => {
    if (resonance.type === "rhythm") {
      const hour = new Date().getHours();
      if (hour >= 6 && hour < 12) return Sun;
      if (hour >= 12 && hour < 18) return Coffee;
      return Moon;
    }
    return Sparkles;
  };

  const Icon = getIcon();

  return (
    <div
      className={cn(
        "inline-flex items-center gap-1 px-2 py-0.5 rounded-full",
        "bg-purple-500/10 text-purple-600 border border-purple-500/20",
        "text-[10px] font-medium",
        "animate-fade-in",
        className
      )}
    >
      <Icon className="w-2.5 h-2.5" />
      <span className="truncate max-w-[120px]">{resonance.description}</span>
    </div>
  );
};

